import React from 'react';

export default function Component(props) {

  const { question, answersList, SurveyAttributes, ansTextBoxChange1, surveyScreenData, clickOK } = props;



  function matchAnswer(answersList1, question1) {
    let value = "";
    if (answersList1 && answersList1.length > 0) {
      let getIndex1 = answersList1.findIndex(item => item.questionId === question1.id);
      if (getIndex1 !== -1) {
        value = answersList1 && answersList1[getIndex1] && answersList1[getIndex1].answer1 ? answersList1[getIndex1].answer1 : "";
      }
    }
    return value
  }

  return (
    <>
      <div className="w-full 2xl:w-4/5 xl:w-1/2 lg:w-11/12">
        <textarea
          rows={2} cols={50}
          value={matchAnswer(answersList, question)}
          onChange={(event) => ansTextBoxChange1(event, question)}
          className="w-full bg-white text-[#212121] rounded-md md:mt-2 p-3 text-sm placeholder-[#212121]/70 outline-none border border-[#212121] font-medium"
          placeholder={SurveyAttributes("WriteHereText") ? SurveyAttributes("WriteHereText") + "..." : "Write here..."} />
      </div>
    </>
  );
}